/* eslint-disable no-plusplus */
/* eslint-disable func-style */
// Sticky tabs
((document) => {
  // Get the elements
  const header = document.querySelector('.js-site-primary-nav');
  const uspBanner = document.querySelector('.usp-info-cards-dark');
  const nav = document.querySelector('.js-primary-nav');
  const overviewNav = document.querySelector('.js-overview-nav');
  const billboard = document.querySelector('.js-sticky-content-offset');
  const stickyTabs = document.querySelector('.js-sticky-tabs');
  const placeholder = document.querySelector('.js-tabs-placeholder');
  const tabItems = document.querySelectorAll('.js-sticky-tabs .tabs__item');
  const primaryNavUser = document.querySelector('.js-primary-nav__user');
  const mobileView = window.matchMedia('(max-width: 640px)');

  // Get the height and distance values
  const headerHeight = header.getBoundingClientRect().height;
  const stickyTabsHeight = stickyTabs.getBoundingClientRect().height;
  let stickyTabsTop = stickyTabs.getBoundingClientRect().top;
  const tabsOrigPos =
    billboard.getBoundingClientRect().bottom - stickyTabsHeight + window.pageYOffset;
  let activeSectionId = null;

  const tabItemsClick = (tabClickEvent) => {
    for (let i = 0; i < tabItems.length; i += 1) {
      tabItems[i].classList.remove('is-active');
    }
    const clickedTab = tabClickEvent.currentTarget;
    clickedTab.classList.add('is-active');
  };

  for (let i = 0; i < tabItems.length; i++) {
    tabItems[i].addEventListener('click', tabItemsClick);
  }

  // Find the closest section based on scroll position
  const getClosestSection = () => {
    let closestSection = null;
    let closestDistance = Infinity;

    tabItems.forEach((tab) => {
      const sectionId = tab.getAttribute('href');
      const section = document.querySelector(sectionId);

      const distance = Math.abs(section.getBoundingClientRect().top);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestSection = sectionId;
      }
    });

    return closestSection;
  };

  // Update active section based on scroll position
  const updateActiveSection = () => {
    const closestSectionId = getClosestSection();

    if (activeSectionId !== closestSectionId) {
      activeSectionId = closestSectionId;

      tabItems.forEach((tab) => {
        const sectionId = tab.getAttribute('href');
        if (sectionId === activeSectionId) {
          tab.classList.add('is-active');
          if (mobileView.matches) {
            const activeLink = document.querySelector('.tabs--scroll-mobile > .is-active');
            activeLink.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'center',
            });
          }
        } else {
          tab.classList.remove('is-active');
        }
      });
    }
  };

  stickyTabsTop = stickyTabs.getBoundingClientRect().top;

  if (stickyTabsTop <= headerHeight) {
    stickyTabs.classList.add('sticky-tabs--are-fixed');
  }

  if (window.scrollY + headerHeight < tabsOrigPos) {
    stickyTabs.classList.remove('sticky-tabs--are-fixed');
  }

  const stickyNavInit = () => {
    stickyTabsTop = stickyTabs.getBoundingClientRect().height;
    const stickyTabsTopOverview = stickyTabsTop / 2 + 5;
    const primaryNavUserHeight = primaryNavUser.getBoundingClientRect().height;
    const headerHeightNew =
      header.getBoundingClientRect().height + uspBanner.getBoundingClientRect().height;
    const navHeightNew = nav.getBoundingClientRect().height;

    if (stickyTabsTop <= headerHeight) {
      stickyTabs.classList.add('sticky-tabs--are-fixed');
      // When the user nav has the class of sticky get the height of it
      if (primaryNavUser && primaryNavUser.classList.contains('is-sticky')) {
        stickyTabs.style.top = `${primaryNavUserHeight}px`;
        placeholder.style.paddingTop = `${stickyTabsTop}px`;
      } else if (mobileView && nav.classList.contains('is-sticky')) {
        stickyTabs.style.top = `${navHeightNew}px`;
        placeholder.style.paddingTop = `${stickyTabsTop}px`;
      } else if (overviewNav) {
        stickyTabs.style.top = `${headerHeightNew}px`;
        placeholder.style.paddingTop = `${stickyTabsTopOverview}px`;
      } else {
        stickyTabs.style.top = `${headerHeightNew}px`;
        placeholder.style.paddingTop = `${stickyTabsTop}px`;
      }
    }

    if (window.scrollY + headerHeight < tabsOrigPos) {
      stickyTabs.classList.remove('sticky-tabs--are-fixed');
      stickyTabs.removeAttribute('style');
      placeholder.removeAttribute('style');
    }
  };

  let scrollingTimeout;

  window.addEventListener(
    'scroll',
    () => {
      // Clear timeout while still scrolling
      window.clearTimeout(scrollingTimeout);

      // Timeout runs after scrolling ends
      scrollingTimeout = setTimeout(() => {
        updateActiveSection();
        stickyNavInit();
      }, 50);
    },
    false,
  );

  const throttled = (delay, fn) => {
    let lastCall = 0;
    return (...args) => {
      const now = new Date().getTime();
      if (now - lastCall < delay) {
        return;
      }
      lastCall = now;
      // eslint-disable-next-line consistent-return
      return fn(...args);
    };
  };

  throttled(200, window.addEventListener('scroll', stickyNavInit));

  // Window resize function
  const hadleWindowResize = () => {
    stickyNavInit();
  };

  // Add a listener to resize
  let eventEnd;
  window.addEventListener('resize', () => {
    clearTimeout(eventEnd);
    eventEnd = setTimeout(hadleWindowResize, 100);
  });

  vm.onload(() => {
    if (stickyTabs.classList.contains('sticky-tabs--are-fixed')) {
      stickyTabs.classList.remove('sticky-tabs--are-fixed');
    }
  });

  vm.jsImport('/js/modules/dist/smooth-scroll.js');

  // keep the chosen tab in viewport sight (mobile)
  document.addEventListener('DOMContentLoaded', () => {
    const activeTab = document.querySelector('.tabs__item.is-active');

    const tabRect = activeTab.getBoundingClientRect();

    if (tabRect.left < 0 || tabRect.right > window.innerWidth) {
      activeTab.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center',
      });
    }
  });
})(document);
